export const MACOS_PLATFORMS_ARRAY = [
  'Macintosh',
  'MacIntel',
  'MacPPC',
  'Mac68K',
];
